import { render, staticRenderFns } from "./VerticalBarRanking.vue?vue&type=template&id=66923c7a&"
import script from "./VerticalBarRanking.vue?vue&type=script&lang=js&"
export * from "./VerticalBarRanking.vue?vue&type=script&lang=js&"
import style0 from "./VerticalBarRanking.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports